<template>
    <BasicHeader pretitle="aqfer Marketing Data Platform" title="Sandbox Jobs" :buttonText="'Create Job'"
        :buttonDisabled="!isDevSandboxSelected" @btnClick="onCreateJobClick" />
    <div class="container-fluid">
        <input-field v-if="sandBoxListOptions.length" label="Choose a Sandbox" type="select" :options="sandBoxListOptions" v-model="selectedSandbox"
            class="mb-0" />
        <div class="tab-container" v-if="!loading && isDevSandboxSelected">
            <nav-header :navItems="[
                {
                    name: 'Jobs',
                    link: {
                        name: 'Sandbox Jobs',
                        params: {
                            sandboxId: `${selectedSandbox}`
                        },
                    },
                },
                {
                    name: 'Pipelines',
                    link: {
                        name: 'Sandbox Pipelines',
                        params: {
                            sandboxId: `${selectedSandbox}`
                        },
                    },
                }
            ]" :breadcrumbTitle="false">
            </nav-header>
            <div class="">
                <router-view :selectedSandbox="selectedSandbox"></router-view>
            </div>
        </div>
        <div v-else-if="!loading && sandboxesReady && !sandBoxListOptions.length">
            <div class="alert alert-secondary" role="alert">
                No Sandboxes available!
            </div>
        </div>
    </div>
</template>

<script>
import BasicHeader from '../../components/BasicHeader.vue';
import InputField from "../../components/InputField.vue";
import NavHeader from "../../components/NavHeader.vue";
import { mapActions } from 'vuex';
export default {
    components: { NavHeader, BasicHeader, InputField },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        selectedSandbox: {
            get() {
                return this.$store.state.sandbox.currentSandbox;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch('sandbox/setCurrentSandbox', value);
                    if (this.$route.name == "Sandbox Pipelines") {
                        this.$router.push({
                            name: "Sandbox Pipelines",
                            params: {
                                sandboxId: `${value}`
                            },
                        });
                    } else {
                        this.$router.push({
                            name: "Sandbox Jobs",
                            params: {
                                sandboxId: `${value}`
                            },
                        });
                    }
                }
            }
        },
        sandboxesReady() {
            return this.$store.state.sandbox.sandboxesReady;
        },
        // currentSandbox can be a prod/prodV2 sandbox carried over from another page; only a dev sandbox is valid here
        isDevSandboxSelected() {
            return this.sandBoxListOptions.some((option) => option.value === this.selectedSandbox);
        },
        sandBoxListOptions() {
            return this.$store.state.sandbox.devSandboxes ? this.$store.state.sandbox.devSandboxes.map((sandbox) => {
                return { "label": sandbox.name, "value": sandbox.name };
            }) : [];
        },
    },
    methods: {
        ...mapActions({
            fetchJobKinds: "amdp/fetchJobKinds",
        }),
        setCurrentSandbox(sandbox) {
            this.$store.dispatch('sandbox/setCurrentSandbox', sandbox)
        },
        onCreateJobClick() {
            this.$store.dispatch('showModal', {
                component: 'AddSandboxJob',
            })
        },
    },
    async beforeMount() {
        this.loading = true;
        try {
            if (this.$route.path.indexOf('/items') == -1 && this.$route.path.indexOf('/pipelines') == -1) {
                this.$router.push({
                    name: "Sandbox Jobs",
                    params: {
                        sandboxId: `${this.$store.state.sandbox.currentSandbox}`
                    },
                });
            }
            this.fetchJobKinds();
        } catch (error) {
            console.error(error);
        } finally {
            this.loading = false;
        }
    }
}
</script>

<style></style>